// gatsby-browser.js (root me)
import "./src/styles/global.css";
import wrapWithProvider from "./wrap-with-provider";

// ✅ Mixpanel service import
import analytics from "./src/utils/analytics";

// Redux (ya jo bhi) provider wrap — keep this
export const wrapRootElement = wrapWithProvider;

// ✅ App boot par Mixpanel init (EU api_host configs se aa raha hai)
export const onClientEntry = () => {
  analytics.init();          // MUST: Mixpanel init once on client
  //analytics.startSession();  
};

// ✅ Har route change par SPA page view
export const onRouteUpdate = ({ location }) => {
  // Map pathname to screen name for analytics
  const pathToScreenMap = {
    '/': 'Home',
    '/qara/': 'QARA',
    '/cry-analyser/': 'Cry Analyser',
    '/experts/': 'Experts',
    '/for-you/': 'For You',
    '/assessment/': 'Assessment',
    '/profile/': 'Profile',
    '/login/': 'Login',
    '/welcome/': 'Welcome',
    '/enter-name/': 'Enter Name',
    '/verify-otp/': 'Verify OTP',
    '/privacy-policy/': 'Privacy Policy',
    '/terms-of-service/': 'Terms of Service',
    '/referral/': 'Referral',
    '/review-login/': 'Review Login'
  };

  // One-time suppression: if we are immediately redirecting guests from '/' to '/welcome',
  // skip emitting Home screen view for this load (session-only flag set in index.js)
  try {
    if (location && location.pathname === '/' && typeof window !== 'undefined' && window.sessionStorage) {
      const suppressOnce = window.sessionStorage.getItem('suppress_home_view_once');
      if (suppressOnce === '1') {
        window.sessionStorage.removeItem('suppress_home_view_once');
        return; // do not track Home for this initial, redirecting load
      }
    }
  } catch (_) {}

  const pageName = pathToScreenMap[location.pathname] || 
    location.pathname.replace(/^\/|\/$/g, '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Unknown';
  
  // Track screen view with proper analytics
  analytics.trackScreenView(pageName, {
    path: location.pathname,
    search: location.search,
    hash: location.hash,
    entry_point: 'navigation',
    timestamp: new Date().toISOString()
  });
};
